import React, { useState } from 'react';

import CompareButton from './subcomponents/CompareButton';
import Table, { Props as TableProps } from './subcomponents/Table';

import { Container, Overlay, TableWrapper } from './CourseCompare.styled';

export type Props = Omit<TableProps, 'close'>;

const CourseCompare: React.FC<Props> = props => {
    const { courses, removeCourse, clearCourses } = props;
    const [isOpen, setIsOpen] = useState(false);

    return (
        <>
            {isOpen && (
                <Overlay
                    onClick={() => setIsOpen(false)}
                    role="button"
                    aria-label="Click the overlay background to close the modal"
                />
            )}
            {courses.length > 0 && (
                <Container>
                    <CompareButton
                        onClick={() => setIsOpen(!isOpen)}
                        isOpen={isOpen}
                        count={courses.length}
                        aria-controls="course-compare-information"
                        className={`m-course-compare m-course-compare-${isOpen ? 'close' : 'open'}`}
                    />
                    <TableWrapper
                        id="course-compare-information"
                        $isOpen={isOpen}
                        aria-hidden={!isOpen}
                        role="dialog"
                        aria-modal={true}
                        aria-label="Course comparison information"
                    >
                        <Table
                            courses={courses}
                            clearCourses={clearCourses}
                            removeCourse={removeCourse}
                            close={() => setIsOpen(false)}
                        />
                    </TableWrapper>
                </Container>
            )}
        </>
    );
};

export default CourseCompare;
